import { render } from "./ValidJustifications.vue?vue&type=template&id=0ccd8768"
import script from "./ValidJustifications.vue?vue&type=script&lang=js"
export * from "./ValidJustifications.vue?vue&type=script&lang=js"

import "./ValidJustifications.vue?vue&type=style&index=0&id=0ccd8768&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__